/**
 * Who performed an audit event. Drives the "Performed By" role line on each row, together with the
 * acting portal user's patient-relationship type (which separates the patient from a proxy).
 * Mirrors the API `AuditActorType` (persisted `byte` values — do not renumber).
 */
export enum AuditActorType {
  /** A patient-portal user (the patient themselves or a proxy). */
  PortalUser = 1,
  /** An admin/staff user acting in the dashboard. */
  AdminUser = 2,
}
